import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInputForm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconInputForm"><Path d="M8.25 3C8.66421 3 9 3.33579 9 3.75V20.25C9 20.6642 8.66421 21 8.25 21C7.83579 21 7.5 20.6642 7.5 20.25V3.75C7.5 3.33579 7.83579 3 8.25 3Z" fill="currentColor"/><Path d="M6 18H2.75C2.33579 18 2 17.6642 2 17.25V6.75C2 6.33579 2.33579 6 2.75 6H6V18Z" fill="currentColor"/><Path d="M21.25 6C21.6642 6 22 6.33579 22 6.75V17.25C22 17.6642 21.6642 18 21.25 18H10.5V6H21.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInputForm;
